<template>
  <div class="notice-panel">
    <div class="notice-head">
      <span class="notice-title">Notifications</span>
      <el-button type="text" size="mini" :loading="loading" @click="loadNotices">Refresh</el-button>
    </div>
    <div v-loading="loading" class="notice-body">
      <div v-if="!loading && !list.length" class="notice-empty">
        <i class="el-icon-message"></i>
        <p>No pending alerts</p>
      </div>
      <ul v-else class="notice-list">
        <li
          v-for="item in list"
          :key="item.id"
          class="notice-item"
          @click="onItemClick"
        >
          <div class="notice-item-top">
            <span class="notice-item-title">{{ item.title || 'Alert' }}</span>
            <el-tag :type="levelType(item.level)" size="mini">{{ item.level || 'INFO' }}</el-tag>
          </div>
          <div class="notice-item-meta">
            <span>{{ item.content || '-' }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="notice-foot">
      <el-button type="text" size="small" @click="goAll">View All Alerts</el-button>
    </div>
  </div>
</template>

<script>
import { alertApi } from '@/api/health'

export default {
  name: 'HeaderNoticePanel',
  data() {
    return {
      loading: false,
      list: [],
      total: 0
    }
  },
  methods: {
    levelType(level) {
      if (level === 'RED') return 'danger'
      if (level === 'AMBER') return 'warning'
      if (level === 'GREEN') return 'success'
      return 'info'
    },
    async loadNotices() {
      this.loading = true
      try {
        const res = await alertApi.list({
          pageNum: 1,
          pageSize: 8,
          status: 'active'
        })
        const data = res.data || {}
        this.list = data.records || data.list || []
        this.total = Number(data.total || 0)
        this.$emit('count-change', this.total)
      } catch (e) {
        this.list = []
        this.total = 0
        this.$emit('count-change', 0)
      } finally {
        this.loading = false
      }
    },
    onItemClick() {
      this.$emit('navigate')
      this.$router.push('/health/alert')
    },
    goAll() {
      this.$emit('navigate')
      this.$router.push('/health/alert')
    }
  }
}
</script>

<style scoped>
.notice-panel {
  max-height: 420px;
  display: flex;
  flex-direction: column;
}
.notice-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}
.notice-title {
  font-weight: 600;
  color: #1d2129;
}
.notice-body {
  min-height: 120px;
  max-height: 320px;
  overflow-y: auto;
  padding: 8px 0;
}
.notice-empty {
  text-align: center;
  color: #86909c;
  padding: 32px 0;
}
.notice-empty i {
  font-size: 28px;
  margin-bottom: 8px;
}
.notice-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.notice-item {
  padding: 10px 4px;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
}
.notice-item:hover {
  background: #fafafa;
}
.notice-item-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}
.notice-item-title {
  font-size: 13px;
  font-weight: 600;
  color: #1d2129;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.notice-item-meta {
  font-size: 12px;
  color: #86909c;
  line-height: 1.4;
}
.notice-foot {
  border-top: 1px solid #f0f0f0;
  padding-top: 4px;
  text-align: center;
}
</style>
